// Arrange screen in the parent app, in English (see boardConfigApp.nl.ts).
export const appBoardConfigEn = {
    open: 'Arrange screen',
    title: 'Arrange screen',
    intro: 'Move the widgets in the grid and make them narrower, wider, shorter or taller: the bigger, the more they show. A board has up to 12 pages; on the board you swipe sideways to the next one.',
    standard: 'This board shows the standard layout. Change something to make your own.',
    onBoard: 'On the board',
    available: 'Add',
    nothingToAdd: 'All widgets of your modules are already on.',
    empty: 'Nothing on this page yet. Add something below.',
    size: 'Size',
    style: 'Style',
    moveUp: 'Move {name} up',
    moveDown: 'Move {name} down',
    remove: 'Remove {name}',
    pageEarlier: 'Move {name} earlier',
    pageLater: 'Move {name} later',
    pageRemove: 'Remove {name}',
    onPage: 'On {name}',
    weekSketch: "The week's agenda",
    phoneHint: 'Moving and resizing works on a tablet or computer. Here you choose what is on each page.',
    add: 'Add {name}',
    reset: 'Standard layout',
    save: 'Save',
    saved: 'Saved. The board adjusts within a minute.',
    resetDone: 'The standard layout is ready. Save to put it on the board.',
    failed: 'Saving did not work. Try again shortly.',
    conflict: 'This board was changed meanwhile, perhaps on the board itself. The latest layout is shown now.',
    preview: 'Preview',
    previewNote: 'With sample data; the board uses yours.',
    screen: 'Screen',
    screens: { large: 'iPad', wide: 'Wide tablet', compact: 'Small tablet' },
    gestureTitle: 'Adjust on the board itself',
    gestureBody: 'Tap the clock on the board three times quickly and enter your parent PIN. It closes by itself after a minute without taps.',
    pinTitle: 'My parent PIN',
    pinBody: 'Use your own PIN. Each parent has a personal PIN.',
    pinLabel: 'New parent PIN',
    pinSave: 'Save PIN',
    pinSaved: 'Your parent PIN is saved.',
    pinInvalid: 'Choose 4 to 6 digits.',
    pinTaken: 'Another parent already uses this PIN. Choose a different one.',
    back: 'Back to Tablets',
    names: {
        prayer: 'Prayer times',
        weather: 'Weather',
        tasks: 'Tasks',
        rides: 'Drop-off and pick-up',
        meals: 'Meals',
        upcoming: 'Coming up',
        messages: 'Messages',
        memorize: 'Learning surahs',
        dinner: 'Who is eating',
        bookings: 'Bookings',
        precip: 'Precipitation',
        week: 'Week (min and max)',
        quran: 'Quran listening',
        todos: 'To-dos',
        notes: 'Notes',
        // 0068: Gezond op gewicht.
        kompas: 'Healthy habits (Healthy weight)',
        // 0076: schoolplanner (nooit een cijfer op het bord).
        school: 'School (homework and tests)',
        // 0062: module Jodendom.
        shabbat: 'Shabbat and calendar',
        // 0061: Kerk & kalender.
        seasons: 'Church & calendar',
        // 0063: module Hindoeïsme.
        almanac: 'Panchang and festivals',
        // UX-ronde bord: Boodschappen (module Eten) en Beloningen.
        groceries: 'Groceries',
        rewards: 'Rewards',
        // 0075: Huisronde (module Eten).
        house_round: 'House round',
        // Widgets compleet: Wensen, Foto (Fotolijst), Timer, Schoonmaak en Beurtrooster.
        wishes: 'Wishes',
        photo: 'Photo (Photo frame)',
        timer: 'Timer',
        cleaning: 'Cleaning',
        rotation: 'Chore rota',
        // Widgets privé (0077): de gewone nieuwe widgets en de privé-widgets.
        clock: 'Clock',
        travel: 'Departure',
        stock: 'Stock',
        cookbook: 'Cookbook',
        reminders: 'Reminders',
        checkin: 'Check-in',
        fasting: 'Fasting',
        growth: 'Growth',
        money: 'Money matters',
        expenses: 'Shared costs',
        my_todos: 'Private to-dos',
        circle: 'Family circle',
    },
    sizes: { S: 'Small', M: 'Medium', L: 'Large', XL: 'Extra large' },
    sizeHints: {
        S: 'The key thing at a glance',
        M: 'Today',
        L: 'Today and tomorrow, in more detail',
        XL: 'Everything, on a wide screen',
    },
    /** Fijnslijpen ouderapp: Brengen en halen, de ophaaltijd als schakelaar (stijl list of no_pickup). */
    ridesPickup: 'Show pick-up time',
    ridesPickupHint: 'For example "Dad picks up 16:50". Off: only who picks up.',
    styles: {
        // Widget Foto.
        slideshow: 'Changes every minute',
        daily: 'Photo of the day',
        no_pickup: 'Without pick-up time',
        list: 'List',
        ring: 'Clock',
        compact: 'Compact',
        illustrated: 'Illustrated',
        today: 'Today only',
        bars: 'Bars',
    },
    /** Koran luisteren: "Over de opnames" bij de widget. */
    quran: {
        aboutTitle: 'About the recordings',
        aboutBody: 'Recitation by {name}. Source: {source}.',
        familyOnly: 'No licence is known: these recordings are for your family only.',
        none: 'No recordings for your family yet.',
    },
    /** Voorbeeldgezin in het voorbeeld van "Scherm inrichten" (kiosk-ui widgets/sample.ts). */
    samples: {
        // Widgets compleet: wensen, klussen en een bijschrift van het voorbeeldgezin.
        wishLego: 'Lego spaceship',
        wishBook: 'Animal book',
        wishSkates: 'Inline skates',
        choreBathroom: 'Bathroom',
        choreVacuum: 'Vacuuming',
        choreBins: 'Take out the bins',
        photoCaption: 'Summer by the sea',
        school: 'School',
        swimming: 'Swimming lesson',
        judo: 'Judo',
        brushTeeth: 'Brush teeth',
        packBag: 'Pack school bag',
        makeBed: 'Make the bed',
        setTable: 'Set the table',
        groceries: 'Groceries',
        birthday: 'Noor turns 8',
        autumnBreak: 'Autumn half-term',
        pasta: 'Pasta pesto',
        soup: 'Soup',
        curry: 'Curry',
        pancakes: 'Pancakes',
        pizza: 'Pizza',
        stew: 'Shepherd’s pie',
        inHours: '{n} h',
        paintCupboard: 'Paint the shoe cupboard',
        fixBike: 'Fix the bike tyre',
        clearGutter: 'Clear the gutter',
        noteMilk: 'We are out of milk',
        noteSwim: 'Do not forget the swim bag',
        // UX-ronde bord: voorbeeld voor de widgets Boodschappen en Beloningen.
        milk: 'Milk',
        bread: 'Bread',
        apples: 'Apples',
        cheese: 'Cheese',
        cinema: 'Cinema',
    },
};
//# sourceMappingURL=boardConfigApp.en.js.map